import './hero.css';

export default ({ icon, title }) => {
  return <div className="row row-bg-dark">
    <div className="flex-col hero-container slim-hero-container">
      <h2>{title}</h2>
    </div>
  </div>
}